import RowCheckController from "../row_check_controller";

export default class extends RowCheckController {
  toggleCollapseIcon(e){
    var version_id = e.target.getAttribute("data-version-id")
    $(`#toggle-icon-${version_id}`).toggleClass('fa-chevron-up');
    $(`#toggle-icon-${version_id}`).toggleClass('fa-chevron-down');
  }
}
